import { useApprovingInvoiceReportJournalEntries } from '@/context/services/approving_invoice_reports';
import type { ApprovingInvoiceReportJournalEntry } from 'ap-openapi';
import { useMemo } from 'react';

export const useJournalEntries = (reportId: string) => {
  const { data } = useApprovingInvoiceReportJournalEntries(reportId);
  const listColumns = useMemo(() => {
    return data?.entry_fields ?? [];
  }, [data]);

  const items = useMemo(() => {
    const source: ApprovingInvoiceReportJournalEntry[] = data?.entries ?? [];
    return source.map((item, index: number) => ({
      ...item,
      id: `${reportId}-${index}`,
    }));
  }, [data, reportId]);

  return { data: items, listColumns };
};

export const useDefaultPagination = () => {
  return useMemo(
    () => ({
      currentPage: 1,
      maxPage: 1,
      perPage: 1,
      maxRecord: 0,
    }),
    []
  );
};
